import React from "react"
import styles from "./styles.scss"
import FieldWrapper from "components/FieldWrapper"
import { reduxForm } from "redux-form"
import { Button, TYPES } from "components/Button"

class Form extends React.Component {

  render() {
    return (
      <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <h2>Maila oss, så kontaktar vi dig!</h2>
        <p>Maila era uppgifter till oss så kontaktar vi er med mer information om vad vi behöver för att lägga till er företag.</p>
        <form onSubmit={this.props.handleSubmit}>
          <FieldWrapper
            label="Företagsnamn"
            placeholder="Företagsnamn"
            name="companyName"
            component="input"
            type="text"
            className={styles.companyNameField}
          />
          <div className={styles.halfInputFields}>
          <FieldWrapper
            label="Ditt namn"
            placeholder="Förnamn Efternamn"
            name="name"
            component="input"
            type="text"
            className={styles.halvField}
          />
          <FieldWrapper
            label="E-postadress"
            placeholder="exempel@mail.se"
            name="email"
            component="input"
            type="text"
            className={styles.halvField}
          />
          </div>
          <Button buttonType={TYPES.SUCCESS}>Bli kontaktad</Button>
        </form>
      </div>
      </div>
    )
  }
}

Form = reduxForm({
  form: "contactForm",
})(Form)

export default Form



// WEBPACK FOOTER //
// src/pages/InfoPage/Form/index.jsx